module.exports = __webpack_public_path__ + "static/media/Microsoft Lumia 950 Black.c16aee4f.png";